import { Box, Button, Card, Footer, Grommet, Header, Main, Nav, Page, PageContent, Text } from "grommet";
import { Currency, Twitch } from "grommet-icons";
import { PageLayout } from "../components/PageLayout";
import { WhatYouWishLogo } from "../icons/WhatYouWishLogo";

export const HomePage = () => {
    return (
        <Box style={{ minHeight: '100vh' }} background={'#1d1f27'} direction="column">
            <Header
                fill="horizontal"
                pad={{ horizontal: 'medium', vertical: 'small' }}
                style={{ position: 'sticky', top: 0, zIndex: 1 }}
                background="background-front"
            >
                <Button>
                    <Box
                        direction="row"
                        align="start"
                        gap="medium"
                        pad={{ vertical: 'none' }}
                        responsive={false}
                    >
                        <Text className="logo-text">Snowerlay</Text>
                    </Box>
                </Button>
                {/* <Nav direction="row" background="background-front" pad="none" align='end'>
                    <Button primary label={'Sign In'} icon={<Twitch />} />
                </Nav> */}
            </Header>
            <Main flex="grow">
                <PageLayout />
            </Main>
            <Footer pad={'medium'} background="background-front">
                <Text size="xsmall">
                    &copy; {new Date().getFullYear()} Snowerlay
                </Text>
                <Box direction='row' align='center' gap='medium'>
                    <Button style={{fontSize: '14px', lineHeight: '16px'}} href='https://donatello.to/codehilation' target='_blank'>{<Box direction='row' align='center' gap='small'><Currency />Support author</Box>}</Button>
                    <Button style={{fontSize: '14px', lineHeight: '16px'}} href='https://www.twitch.tv/codehilation' target='_blank'>Developed by CodehilatioN</Button>
                    <Button style={{fontSize: '14px', lineHeight: '16px'}} plain label="Other projects:" reverse icon={<WhatYouWishLogo height="25px" width="100px" />} href="https://whatyouwish.pro/" target="_blank" />
                </Box>
            </Footer>
        </Box>
    )
}